//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/** Question Type */
export enum AnswerDisplay {
  /** Single answer */
  Single = 0,
  /** Multiple */
  Multiple = 1,
  /** Image */
  Image = 2,
  /** Text */
  Text = 3,
  /** Image and Text */
  ImageAndText = 4,
  /** Score */
  Score = 5,
  /** Counter */
  Counter = 6,
  /** Dropdown */
  Dropdown = 7,
  /** Video Carousel */
  VideoCarousel = 8,
}
